/*global addTranslations*/
import React, { Component, PropTypes } from 'react';
import { Toolbar, ToolbarGroup, ToolbarButton } from 'cio';
import css from './css';
import PageModuleActions from 'actions/PageModule';
import classNames from 'classnames';
import Delete from 'cio/lib/Assets/Delete';
import Eye from 'cio/lib/Assets/Eye';
import Edit from 'cio/lib/Assets/Edit';
import { translate as _l } from 'oxygen-i18n';
import { ToolbarTitle, Dialog, Button, ButtonGroup } from 'cio';
import { Units } from 'Css';

addTranslations({
  ['en-US']: {
    'Are you sure you want to remove this module?':
      'Are you sure you want to remove this module?',
    Delete: 'Delete',
    No: 'No'
  },
  ['sv-SE']: {
    'Are you sure you want to remove this module?':
      'Är du säker på att du vill ta bort modulen?',
    Delete: 'Ta bort',
    No: 'Nej'
  }
});

class PageModule extends Component {
  static propTypes = {
    children: PropTypes.node,
    icon: PropTypes.node,
    id: PropTypes.number,
    mode: PropTypes.string
  };

  state = {
    deleteDialog: false
  };

  editMode = () => {
    const { id } = this.props;
    PageModuleActions.changePageModuleMode(id, 'edit');
  };

  deleteModule = () => {
    const { id } = this.props;
    PageModuleActions.deletePageModule(id);
  };

  detailMode = () => {
    const { id } = this.props;
    PageModuleActions.changePageModuleMode(id, 'detail');
  };

  render() {
    const { mode, icon, editor, children } = this.props;
    const { deleteDialog } = this.state;
    return (
      <div
        className={classNames(css.root, {
          [css.edit]: mode === 'edit'
        })}
      >
        {mode === 'edit' && (
          <Toolbar zDepth={1} transparent>
            <ToolbarGroup className={css.leftToolbarGroup} transparent />
            <ToolbarGroup
              className={css.toolbarHeader}
              transparent
              fullWidth
              center
            >
              {icon}
            </ToolbarGroup>
            <ToolbarGroup transparent className={css.leftToolbarGroup}>
              <ToolbarButton dense onTouchTap={this.detailMode}>
                <Eye />
              </ToolbarButton>
              <ToolbarButton
                dense
                onTouchTap={() => this.setState({ deleteDialog: true })}
              >
                <Delete />
              </ToolbarButton>
            </ToolbarGroup>
          </Toolbar>
        )}
        {editor &&
          mode !== 'edit' && (
            <Toolbar dense transparent>
              <ToolbarGroup fullWidth center />
              <ToolbarGroup>
                <ToolbarButton onTouchTap={this.editMode}>
                  <Edit />
                </ToolbarButton>
              </ToolbarGroup>
            </Toolbar>
          )}
        {children}
        <Dialog
          open={deleteDialog}
          onRequestClose={() => this.setState({ deleteDialog: false })}
        >
          <ToolbarTitle>{_l`Delete`}</ToolbarTitle>
          <div className={css.panel}>
            {_l`Are you sure you want to remove this module?`}
          </div>
          <ButtonGroup fullWidth>
            <div className={css.buttonContainer}>
              <Button
                label={_l`No`}
                primary
                onTouchTap={() => this.setState({ deleteDialog: false })}
              />
            </div>
            <div className={css.buttonContainer}>
              <Button
                label={_l`Delete`}
                secondary
                onTouchTap={this.deleteModule}
              />
            </div>
          </ButtonGroup>
        </Dialog>
      </div>
    );
  }
}

export default PageModule;



// WEBPACK FOOTER //
// ./src/js/module/PageModule.js